/**
 * 
 * 数字门户 所需要的信息 token/当前登陆用户信息
 * 
 * ***/
import { checkBackupRestoreStatus } from '@/apis/modules/npgw/cms/site_backs';
import store from '@/store'
import { getLoginUser, getToken } from 'newapis/public'
import { Loading } from 'element-ui';
import { findOneByMemerCode } from '@@/apis/content-analytics';
// import { setAccessToken } from '@/utils/access_token';

export async function bootstrap() {
    // 获取网站token，获取当前登陆信息
    let result = await Promise.all([getToken(), getLoginUser()]);
    if (result[0]) {
        store.dispatch('numberPortal/setToken', result[0].data.token)
        sessionStorage.setItem('TOKEN', result[0].data.token);
        localStorage.setItem('TOKEN', result[0].data.token);
    }
    if (result[1]) {
        await Promise.all([
            store.dispatch('numberPortal/setUserInfo', result[1].data.user),
            store.dispatch('user/getSaasUserInfo'), // 兼容老的
            store.dispatch('user/loginSaas')
        ])
    }
    // 检查备份，如果网站处于备份状态，直接跳转到备份页面
    backupRecoveryCheck();
}

/**
 * 网站备份还原状态检查
 */
async function backupRecoveryCheck() {
    let loading = undefined;
    while (true) {
        const response = await checkBackupRestoreStatus();
        if (response && response.data) {
            let status = Number(response.data.status);
            if (status === 0 || status === 99) { // 0 无备份任务 99 备份失败
                if (loading) loading.close();
                return true;
            } else {
                if (!loading) loading = Loading.service({ lock: true, text: response.data.remark + '……' });
            }
        }
        await new Promise((resolve) => setTimeout(() => resolve(true), 5000));
    }
}

export async function getUserInfoBy300() {
    const userdata = store.state.user.userdata
    const { data, status }  = await findOneByMemerCode({memberCode: userdata.memberCode})
    if(status===200 && data.status === '200' && data.data) {
        const { memName, alias } = data.data
        memName && store.dispatch('user/setUsername', memName);
        if(memName || alias) {
            userdata.name = memName || userdata.name
            userdata.alias = alias || userdata.userName

            store.dispatch('user/setUserdata', userdata);
            store.dispatch('numberPortal/setUserInfo', userdata)
        }
    }
}